export default __webpack_public_path__ + "static/media/viction-wallet-logo.495f6689.svg";